import { db } from "../../../config/firebaseconfig";
import forOwn from 'mout/object/forOwn'
import {tallyLicensedUsers,tallyLicenseInUserLicenses} from "./tallyLicenses";


export default function addOrRemoveAllToLicense (licenseId,users,addOrRemove) {

  //path to user licenses
  const path = `licenses.${licenseId}`
  var updateEducatorsBatch = db.batch();

  //fetching license from account licenses collection
        var licensedUsers = {};
          forOwn(users,(user)=>{
            licensedUsers[user.id] = addOrRemove;
            if(!user.licenses)
            {
              user.licenses = {
                [licenseId]:addOrRemove
              };
            }
            else if (!user.licenses[licenseId])
            {
              user.licenses[licenseId] = addOrRemove;
            }
            var updateEducator = db.collection('educators').doc(user.id);
            updateEducatorsBatch.update(updateEducator,{
              [path]: addOrRemove
            });
          })
        const usersPath = `licensedUsers`
        const updateData = {
          licensedCount: addOrRemove?tallyLicensedUsers(licensedUsers,'ADD'):tallyLicensedUsers(licensedUsers,'REMOVE'),
          [usersPath]: licensedUsers,
        }
        db.collection('accountLicenses').doc(licenseId).update(updateData);
        updateEducatorsBatch.commit();
  
  return Promise.all([ updateEducatorsBatch])
}


// WEBPACK FOOTER //
// ./src/helpers/users/licenses/addOrRemoveAllToLicense.js